import React, { useLayoutEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import LoginPage from '../src/pages/login/LoginPage'
import MainPage from './pages/main/MainPage'
import Sidebar from './features/common/sidebar/Sidebar'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import UserDetailPage from './pages/user/UserDetailPage'
import PostListPage from './pages/post/post/PostListPage'
import PostCreatePage from './pages/post/post/PostCreatePage'
import CommentListPage from './pages/post/comment/CommentListPage'
import PostDetailPage from './pages/post/post/PostDetailPage'
import CommentDetailPage from './pages/post/comment/CommentDetailPage'
import LeaguePage from './pages/leaderboard/league/LeaguePage'
import RecommendPage from './pages/post/recommend/RecommendPage'
import LeagueCreatePage from './pages/leaderboard/league/LeagueCreatePage'
import LeagueDetailPage from './pages/leaderboard/league/LeagueDetailPage'
import EventPage from './pages/leaderboard/event/EventPage'
import EventCreatePage from './pages/leaderboard/event/EventCreatePage'
import EventDetailPage from './pages/leaderboard/event/EventDetailPage'
import NewsPage from './pages/news/NewsPage'
import AdvertisementPage from './pages/leaderboard/advertisement/AdvertisementPage'
import AdvertisementCreatePage from './pages/leaderboard/advertisement/AdvertisementCreatePage'
import AdvertisementDetailPage from './pages/leaderboard/advertisement/AdvertisementDetailPage'
import ReportPage from './pages/report/ReportPage'
import CopyLeaderPage from './pages/copytrading/leader/CopyLeaderPage'
import CopyLeaderDetailPage from './pages/copytrading/leader/CopyLeaderDetailPage'
import CopierPage from './pages/copytrading/copier/CopierPage'
import CopierDetailPage from './pages/copytrading/copier/CopierDetailPage'
import ApiLogPage from './pages/user/ApiLogPage'
import WithdrawPage from './pages/withdraw/withdrawPage'
import ServerLogsPage from './pages/backend/logs'
import CampaignPage from './pages/leaderboard/Campaign/CampaignPage'
import CampaignCreatePage from './pages/leaderboard/Campaign/CampaignCreatePage'
import CampaignDetailPage from './pages/leaderboard/Campaign/CampaignDetailPage'
import ApiDetailPage from './pages/user/ApiDetailPage'
import DevServer from './pages/backend/devServer'
import AnnounceListPage from './pages/post/announcement/AnnounceListPage'
import AnnounceDetailPage from './pages/post/announcement/AnnounceDetailPage'
import AnnounceCreate from './pages/post/announcement/AnnounceCreate'
import ProListPage from './pages/user/ProListPage'
import ProDetailPage from './pages/user/ProDetailPage'
import ServerAnalysisPage from './pages/analysis/DataAnalysisPage'
import CopyDashboard from './pages/analysis/CopyDashboard'
import ActiveKeysDashBoard from './pages/analysis/ActiveKeys'
import UpbitnftContainer from './features/page/upbitnft/Upbitnft'
import ActiveUsersDashBoard from './pages/analysis/ActiveUser'
import RegisterUsersDashBoard from './pages/analysis/RegisterUser'
import AppInstallDashBoard from './pages/analysis/AppInstall'
import WithdrawDetailPage from './pages/withdraw/WithdrawDetailPage'
import ScrollToTop from './ScrollToTop'
import InvoicesPage from './pages/leaderboard/invoices/Invoices'
import { getUserList } from './apis/user/getUserList'
import DataStat from './pages/analysis/DataStat'
import LeaderboardBannerPage from './pages/leaderboard/banner/LeaderboardBannerPage'
import LeaderboardBannerCreatePage from './pages/leaderboard/banner/LeaderboardBannerCreatePage'
import LeaderboardBannerDetailPage from './pages/leaderboard/banner/LeaderboardBannerDetailPage'
import ProPaymentPage from './pages/user/ProPaymentPage'
import CopyTradingFee from './pages/copytrading/copier/CopyTradingFee'
import PointPage from './pages/point/PointPage'
import AbnormalContainer from './features/page/abnormal/AbnormalContainer'
import AbnormalDetail from './features/page/abnormal/AbnormalDetail'
import PointRetractPage from './pages/point/PointRetractPage'
import FloatingMessagePage from './pages/leaderboard/floatingMessage/floatingMessagePage'
import FloatingMessageCreatePage from './pages/leaderboard/floatingMessage/floatingMessageCreatePage'
import FloatingMessageDetailPage from './pages/leaderboard/floatingMessage/floatingMessageDetailPage'
import ReferralPage from './pages/cashback/referral/ReferralPage'
import ReferralDetailPage from './pages/cashback/referral/ReferralDetailPage'
import WithdrawCashbackPage from './pages/cashback/withdraw/WithdrawCashbackPage'
import HistoryCashbackPage from './pages/cashback/history/HistoryCashbackPage'
import PaytoSeePage from './pages/leaderboard/paytosee/PaytoSeePage'
import { Promotion } from './pages/promotion'
import { TraderMap } from './pages/tradermap_project'
import { TraderMapCampaign } from './pages/tradermap_campaign'
import { LandingPopup } from './pages/landing/popup'
import BadgePage from './pages/leaderboard/badge/BadgePage'
import BadgeCreatePage from './pages/leaderboard/badge/BadgeCreatePage'
import BadgeDetailPage from './pages/leaderboard/badge/BadgeDetailPage'
import UserBadgePage from './pages/leaderboard/badge/UserBadgePage'

import { TradermapVolume } from './pages/tradermap'
import { VolumeLeague } from './pages/volume_league'
import { Feed } from './pages/feed'
import { KeyProbe } from './pages/keyprobe'

const queryClient = new QueryClient()

function App() {
    const [isLogin, setIsLogin] = useState(false)

    useLayoutEffect(() => {
        if (localStorage.getItem('wiz-admin-userToken') && localStorage.getItem('wiz-admin-userId')) {
            setIsLogin(true)
            const isCheck = async () => {
                const data = await getUserList()

                if (data?.code === 404 || data?.Message === 'unauthorized' || data?.error) {
                    setIsLogin(false)
                    alert('This is not an authorized account!')
                    localStorage.removeItem('wiz-admin-userId')
                    localStorage.removeItem('wiz-admin-userToken')
                }
            }
            isCheck()
        }
    }, [])

    return (
        <div className="App bg-line04 min-h-screen">
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <ScrollToTop />
                    <div className={`flex ${!isLogin && 'justify-center'}`}>
                        <Sidebar isLogin={isLogin} setIsLogin={e => setIsLogin(e)} />
                        <Routes>
                            {isLogin ? (
                                <>
                                    <Route path="/" element={<MainPage />} />
                                    <Route path="/login" element={<LoginPage setIsLogin={e => setIsLogin(e)} />} />
                                    <Route path="/user" element={<UserDetailPage />} />
                                    <Route path="/pro" element={<ProListPage />} />
                                    <Route path="/pro/detail" element={<ProDetailPage />} />
                                    <Route path="/pro/history" element={<ProPaymentPage />} />
                                    <Route path="/news" element={<NewsPage />} />
                                    <Route path="/post" element={<PostListPage />} />
                                    <Route path="/post/detail" element={<PostDetailPage />} />
                                    <Route path="/post/create" element={<PostCreatePage />} />
                                    <Route path="/comment" element={<CommentListPage />} />
                                    <Route path="/comment/detail" element={<CommentDetailPage />} />
                                    <Route path="/recommend" element={<RecommendPage />} />
                                    <Route path="/league" element={<LeaguePage />} />
                                    <Route path="/league/create" element={<LeagueCreatePage />} />
                                    <Route path="/league/detail" element={<LeagueDetailPage />} />
                                    <Route path="/event" element={<EventPage />} />
                                    <Route path="/pts" element={<PaytoSeePage />} />
                                    <Route path="/event/create" element={<EventCreatePage />} />
                                    <Route path="/event/detail" element={<EventDetailPage />} />
                                    <Route path="/advertisement" element={<AdvertisementPage />} />
                                    <Route path="/advertisement/create" element={<AdvertisementCreatePage />} />
                                    <Route path="/advertisement/detail" element={<AdvertisementDetailPage />} />
                                    <Route path="/campaign" element={<CampaignPage />} />
                                    <Route path="/campaign/create" element={<CampaignCreatePage />} />
                                    <Route path="/campaign/detail" element={<CampaignDetailPage />} />
                                    <Route path="/report" element={<ReportPage />} />
                                    <Route path="/leader" element={<CopyLeaderPage />} />
                                    <Route path="/leader/detail" element={<CopyLeaderDetailPage />} />
                                    <Route path="/copier" element={<CopierPage />} />
                                    <Route path="/copier/detail" element={<CopierDetailPage />} />
                                    <Route path="/invoices" element={<InvoicesPage />} />
                                    <Route path="/copytrading_fee" element={<CopyTradingFee />} />
                                    <Route path="/api" element={<ApiLogPage />} />
                                    <Route path="/api/detail" element={<ApiDetailPage />} />
                                    <Route path="/api/probe" element={<KeyProbe />} />
                                    <Route path="/withdraw" element={<WithdrawPage />} />
                                    <Route path="/withdraw/detail" element={<WithdrawDetailPage />} />
                                    <Route path="/logs" element={<ServerLogsPage />} />
                                    <Route path="/dev" element={<DevServer />} />
                                    <Route path="/announce" element={<AnnounceListPage />} />
                                    <Route path="/announce/detail" element={<AnnounceDetailPage />} />
                                    <Route path="/announce/create" element={<AnnounceCreate />} />
                                    <Route path="/analysis" element={<ServerAnalysisPage />} />
                                    <Route path="/analysis/intelligence" element={<DataStat />} />
                                    <Route path="/analysis/copy" element={<CopyDashboard />} />
                                    <Route path="/analysis/activekey" element={<ActiveKeysDashBoard />} />
                                    <Route path="/analysis/mau" element={<ActiveUsersDashBoard />} />
                                    <Route path="/analysis/register" element={<RegisterUsersDashBoard />} />
                                    <Route path="/analysis/appinstall" element={<AppInstallDashBoard />} />
                                    <Route path="/nft" element={<UpbitnftContainer />} />
                                    <Route path="/banner" element={<LeaderboardBannerPage />} />
                                    <Route path="/banner/create" element={<LeaderboardBannerCreatePage />} />
                                    <Route path="/banner/detail" element={<LeaderboardBannerDetailPage />} />
                                    <Route path="/floating" element={<FloatingMessagePage />} />
                                    <Route path="/floating/create" element={<FloatingMessageCreatePage />} />
                                    <Route path="/floating/detail" element={<FloatingMessageDetailPage />} />
                                    <Route path="/point" element={<PointPage />} />
                                    <Route path="/retract" element={<PointRetractPage />} />
                                    <Route path="/abnormal" element={<AbnormalContainer />} />
                                    <Route path="/abnormal/detail" element={<AbnormalDetail />} />
                                    <Route path="/referral" element={<ReferralPage />} />
                                    <Route path="/referral/detail" element={<ReferralDetailPage />} />
                                    <Route path="/withdraw_cashback" element={<WithdrawCashbackPage />} />
                                    <Route path="/reward_history" element={<HistoryCashbackPage />} />
                                    <Route path="/promotion" element={<Promotion />} />

                                    <Route path="/tradermap" element={<TradermapVolume />} />
                                    <Route path="/tradermap_project" element={<TraderMap />} />
                                    <Route path="/tradermap_campaign" element={<TraderMapCampaign />} />
                                    <Route path="/volume_league" element={<VolumeLeague />} />
                                    <Route path="/feed" element={<Feed />} />
                                    <Route path="/landing/popup" element={<LandingPopup />} />
                                    <Route path="/badge" element={<BadgePage />} />
                                    <Route path="/badge/create" element={<BadgeCreatePage />} />
                                    <Route path="/badge/detail" element={<BadgeDetailPage />} />
                                    <Route path="/badge/user" element={<UserBadgePage />} />
                                </>
                            ) : (
                                <>
                                    <Route path="*" element={<LoginPage setIsLogin={e => setIsLogin(e)} />} />
                                </>
                            )}
                        </Routes>
                    </div>
                </BrowserRouter>
            </QueryClientProvider>
        </div>
    )
}

export default App
